import { Typography } from '@mui/material'
import React from 'react'
import myimage from '../../assests/images/tushar.jpg'
import Customtimeline, { CustomeTimelineseparator } from '../Timeline/Mytimeline'
import Resumedata from '../../Utilitize/Resumedata'
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import TimelineItem from '@mui/lab/TimelineItem'
import TimelineContent from '@mui/lab/TimelineContent'
import Mybutton from '../Button/Mybutton.js'
import GetAppIcon from '@mui/icons-material/GetApp';
import myresumepdf from '../../assests/Md.shehabuddin-tushar.pdf'

import './Profile.css'

const CustomTimelineItem =({title,text,link})=>{
     
        return(<TimelineItem>
          <CustomeTimelineseparator/>
          <TimelineContent className={'timeline_content'}>
             {link?(<Typography className={'timelineItem_text'}>
               <span>{title}:</span> <a href={link} target="_blank">{text}</a>
             </Typography>):(
             
                <Typography className={'timelineItem_text'}><span>{title}:</span> {text}</Typography>
             )}
            
          </TimelineContent>
        </TimelineItem>)
}




function Profile() {

   
    return (
        <div className="profile container_shadow">
           <div className="profile_name">
                <Typography className="name">{Resumedata.name}</Typography>
                <Typography className="title">{Resumedata.title}</Typography>
           </div>
           <figure className="profile_image">

              <img src={myimage} alt="myimage"/>  
           </figure>

           <div className="profile_information">
              <Customtimeline icon={<PersonOutlineIcon/>}>
                 <CustomTimelineItem title="Name" text={Resumedata.name}/>
                 <CustomTimelineItem title="Title" text={Resumedata.title}/>
                 <CustomTimelineItem title="Email" text={Resumedata.email}/>
               
                
                 <CustomTimelineItem title="Address" text={Resumedata.address}/>
                 <CustomTimelineItem title="Phone" text={Resumedata.phone}/>

                 {Object.keys(Resumedata.socials).map((key)=>{
                        return(
                          <CustomTimelineItem title={key} text={Resumedata.socials[key].text} link={Resumedata.socials[key].link}/>

                        )
                 })}
              </Customtimeline>
             <br/>
             <div className="button_container" style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
               <Mybutton link={myresumepdf} text="Download Resume" icon={<GetAppIcon/>}/>
             </div>
        
           </div>
        </div>
    )
}

export default Profile
